var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cs-group-box" },
    [
      _c("div", { staticClass: "cs-group-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "cs-group",
            class: { active: _vm.activeGroupID === 0 },
            on: {
              click: function ($event) {
                _vm.activeGroupID = 0
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "cs-group-info" },
              [_c("w-fa", { attrs: { icon: "home" } })],
              1
            ),
          ]
        ),
      ]),
      _c(
        "w-scroll-view",
        { staticClass: "group-scroll", attrs: { tag: "div" } },
        [
          _vm.showCustomGroups
            ? _vm._l(_vm.customGroups, function (group) {
                return _c(
                  "div",
                  {
                    key: group.ID,
                    staticClass: "cs-group custom-group",
                    class: {
                      active: _vm.activeGroupID === group.ID,
                      colored: !!group.Color,
                    },
                    style: _vm.customGroupStyle(group),
                    on: {
                      click: function ($event) {
                        return _vm.activateCustom(group)
                      },
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.editCustomGroup(group)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cs-group-info" }, [
                      _vm._v(_vm._s(group.Name)),
                    ]),
                  ]
                )
              })
            : _vm._e(),
          _vm._l(_vm.filteredGroups, function (group) {
            return _c("app-group", {
              key: group.ID,
              class: { active: _vm.activeGroupID === group.ID },
              attrs: { "active-group-id": _vm.activeGroupID, value: group },
              on: {
                activate: function ($event) {
                  return _vm.activate($event)
                },
              },
            })
          }),
          _vm.config
            ? _c(
                "div",
                {
                  staticClass: "cs-group add-group",
                  attrs: {
                    title: _vm.$t("components.sales.Cashier.add-group"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addCustomGroup()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "cs-group-info" },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openGroupModal,
            callback: function ($$v) {
              _vm.openGroupModal = $$v
            },
            expression: "openGroupModal",
          },
        },
        [
          _vm.editGroup
            ? _c("app-custom-group-edit", {
                attrs: { value: _vm.editGroup, "is-new": _vm.editIsNew },
                on: {
                  save: function ($event) {
                    return _vm.saveCustomGroup($event)
                  },
                  delete: function ($event) {
                    return _vm.deleteCustomGroup()
                  },
                  cancel: function ($event) {
                    _vm.openGroupModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "cs-group home-button",
          on: {
            click: function ($event) {
              return _vm.goHome()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "cs-group-info" },
            [
              _c("w-fa", { attrs: { icon: "arrow-left" } }),
              _c("div", { staticClass: "home-label" }, [
                _vm._v(_vm._s(_vm.$t("components.sales.Cashier.back-to-home"))),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }